import { LOADER_STATUS, SAVE_TOTAL_PAGES, SAVE_TOTAL_PAGES_ISD, SAVE_TOTAL_PAGES_PURCHASE, SET_ISD_TABLE_DATA, SET_PURCHASE_TABLE_DATA, SET_TOTAL_RECORDS } from "./constants";

const initialState = {
    loaderStatus: false,
    totalPagesPurchase: 1,
    totalPagesIsd: 1,
    purchaseTableDataStore: [],
    isdTableDataStore: [],
    totalRecords: 0,
}

const gstr6ViewReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SAVE_TOTAL_PAGES_PURCHASE:
        return {
          ...state,
          totalPagesPurchase:action.pages
        }
      case SAVE_TOTAL_PAGES_ISD:
        return {
          ...state,
          totalPagesIsd:action.pages
        }
      case SET_PURCHASE_TABLE_DATA:
        return {
          ...state,
          purchaseTableDataStore:action.data
        }
      case SET_ISD_TABLE_DATA:
        return {
          ...state,
          isdTableDataStore:action.data
        }
      case SET_TOTAL_RECORDS:
        return {
          ...state,
          totalRecords:action.records
        }
        default: return state
    }
}

export default gstr6ViewReducer;